import { render, staticRenderFns } from "./DownloadIconLink.vue?vue&type=template&id=18c8fb5a&scoped=true&"
import script from "./DownloadIconLink.vue?vue&type=script&lang=js&"
export * from "./DownloadIconLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c8fb5a",
  null
  
)

export default component.exports